/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Original_Text_Editor_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Original text editor for event {eventIndex}" |
*
* @param {Event_Original_Text_Editor_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_original_text_editor_aria_label = /** @type {((inputs: Event_Original_Text_Editor_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Original_Text_Editor_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
});